
export const ifBrowser = (fn: () => void): boolean => {
    if (typeof window !== "undefined") {
        fn();
        return true;
    }
    return false;
}

export function getCookie(cname: string): string {
    if (typeof window === "undefined") {
        return "";
    }
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
};

export function getUrlParameter(name: string): string {
    if (typeof window === "undefined") {
        return "";
    }
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export function formatPhoneNumber(s: string): string {
    var s2 = ("" + s).replace(/\D/g, '');
    var m = s2.match(/^(\d{3})(\d{3})(\d{4})$/);
    return (!m) ? null : " " + m[1] + "-" + m[2] + "-" + m[3];
}

// keeps all the text of the element on one line
export const fit = (ref: any) => {
    if (!ref || !ref.current) {
        return;
    }
    const node = ref.current;
  fitText(node)
  window.addEventListener('resize', function() {
    fitText(node)
  })
}

const fitText = (node: any) => {
  if (!node) return

  // hide the element while we find the right size
  node.style.visibility = 'hidden'
  // remove element styles set by last fit
  node.style.fontSize = ''
  node.style.letterSpacing = ''
  node.style.wordSpacing = ''

  const nodeStyle = window.getComputedStyle(node)
  const lineHeight = nodeStyle.lineHeight
  let fontSize = parseInt(nodeStyle.fontSize, 10)

  node.style.lineHeight = '100px'

  const ok = () => {
    // height should drop from 200 to 100 when text fits on 1 line
    return node.getBoundingClientRect().height < 150
  }

  let checks = 0
  const check = () => {
    checks++
    node.style.fontSize = fontSize + 'px'
    window.requestAnimationFrame(() => {
      if (ok()) {
        node.style.lineHeight = lineHeight
        node.style.visibility = ''
        return
      }
      // the second time we try removing spacing rather than decreasing font size
      if (checks == 2) {
        node.style.letterSpacing = '0'
        node.style.wordSpacing = '0'
      } else {
        fontSize--
      }
      check()
    })
  }

  check()
}
